import { useContext } from "react";

import { Container, Grid, Dialog, DialogActions } from "@material-ui/core";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";

import Btn from "../../../../components/buttons/Btn";
import HeaderModule from "../../../../components/header/HeaderModule";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import AccordionPrescricaoCadastroDependente from "./AccordionPrescricaoCadastroDependente";
import AccordionPrescricaoCadastroOlhos from "./AccordionPrescricaoCadastroOlhos";
import AccordionPrescricaoCadastroAro from "./AccordionPrescricaoCadastroAro";
import AccordionPrescricaoCadastroLente from "./AccordionPrescricaoCadastroLente";

import { PainelContainer } from "../styles/Prescricao";

// falta lógica para salvar e abrir prescrição para edição
// mesmo quando for nova prescrição, caso abrir com cliente já selecionado,
// trazer medidas da prescrição anterior para que seja alterado, (nem sempre todas as medidas mudam)

const ModalPrescricaoCadastro = () => {
  const { queryParams } = useContext(QueryParamsContext);
  const { handleAdd } = usePrescricaoController();
  const { modalPrescriptionOpen, setModalPrescriptionOpen } =
    useContext(PrescricaoContext);

  const handleCloseModal = () => {
    setModalPrescriptionOpen(false);
  };

  return (
    <>
      <Dialog
        open={modalPrescriptionOpen}
        fullWidth={true}
        maxWidth="md"
        fullScreen
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <HeaderModule title="PRESCRIÇÃO CADASTRO" />
        <PainelContainer />

        <Container maxWidth="xl">
          <Grid container spacing={3}>
            {queryParams.colaborador === "S" && (
              <AccordionPrescricaoCadastroDependente />
            )}
            <AccordionPrescricaoCadastroOlhos />
            <AccordionPrescricaoCadastroAro />
            <AccordionPrescricaoCadastroLente />
          </Grid>
          <DialogActions>
            <Btn
              label="Cancelar"
              bgcolor="tertiary"
              onClick={handleCloseModal}
            />
            <Btn label="Salvar" onClick={handleAdd} />
          </DialogActions>
        </Container>
      </Dialog>
    </>
  );
};

export default ModalPrescricaoCadastro;
